import $ from 'jquery';

$(function () {
	const path = window.location.href;

	$('ul.navbar-nav li a.nav-link').each(function () {
		$(this).toggleClass('active', this.href === path);
	});

	$('header#header button.navbar-toggler').on('click', function () {
		$(this).toggleClass('active');
		$('.navbar').toggleClass('active');
	});

	$('header#header .close').on('click', function () {
		$('header#header button.navbar-toggler').removeClass('active');
		$('.navbar').removeClass('active');
	});
});
